import React from 'react';
import { Field } from 'redux-form';
import { Alert, Col } from 'react-bootstrap';
import './TravellerMedicalField.scss';
import ScreeningContainer from '../../../../../../../screening/containers/ScreeningContainer';
import { CheckSelect } from '../../../../../../../../common/components/CheckSelect/CheckSelect';
import { useSelector } from 'react-redux';

const TravellerMedicalField = ({ input, tripType, destinations, region, index, onClearError }) => {
  const { isScreening } = useSelector((state) => state.screening);
  const traveller = input.value;
  const conditionsCovered = traveller.conditions_covered;
  const updateTravellerMedical = (results) => {
    const newTraveller = {
      ...traveller,
      ...results,
    };
    input.onChange(newTraveller);
    onClearError();
  };

  return (
    <Col xs={12} className="traveller-medical-field">
      <ScreeningContainer
        travellerIndex={index}
        traveller={traveller}
        region={region}
        tripType={tripType}
        destinations={destinations}
        conditionsCovered={traveller?.conditions_covered}
        onUpdateTraveller={updateTravellerMedical}
      />

      {!!traveller?.screening?.meta && !isScreening && (
        <Field
          name={`${input.name}.conditions_covered`}
          component={CheckSelect}
          checkedValue={false}
          label={'Click here to exclude all medical conditions'}
        />
      )}

      {!isScreening && !conditionsCovered && (
        <div className="warning-message">
          <Alert bsStyle="danger">
            <p>
              <strong>Warning</strong>– we do not recommend you travel without full
              medical cover. Please be aware that your policy will exclude any claims
              arising from or traceable to your pre-existing medical conditions but will
              provide cover for anything unforeseen.
            </p>
            <br />
            By proceeding with the medical exclusion, you are agreeing with the above
            statement.
          </Alert>
        </div>
      )}
    </Col>
  );
};

export default TravellerMedicalField;
